export const SET_NAME = (state, value) => {
  state.name = value
}

export const SET_TELEPHONE = (state, value) => {
  state.telephone = value
}

export const SET_EMAIL = (state, value) => {
  state.email = value
}

export const SET_FAX = (state, value) => {
  state.fax = value
}

export const SET_DEPARTMENT = (state, value) => {
  state.department = value
}

export const SET_DEPARTMENTCODE = (state, value) => {
  state.departmentCode = value
}

export const SET_ACCOUNTASSIGNEDID = (state, value) => {
  state.accountAssignedId = value
}
